
const transactionMixin = {
    methods: {
        transactionMixinGetTransactionName(transactionBatchType, type, status, partnerShortName = '') {
            // Map transaction batch type to get the transaction name
            switch (transactionBatchType) {
                case 'buy':
                    return this.$t('global.transactionTypes.toppedUp');
                case 'deposit':
                    return this.$t('global.transactionTypes.received');
                case 'withdrawal':
                    return (type === 'unlock' && status === 'processed')
                        ? this.$t('global.transactionTypes.transferRefunded')
                        : this.$t('global.transactionTypes.transferred');
                case 'fto_purchase':
                    return this.$t('global.transactionTypes.purchasedDuringFto');
                case 'bonus':
                    return this.$t('global.transactionTypes.bonus');
                case 'redeem_voucher':
                    return this.$t('global.transactionTypes.freeVoucher', {
                        name: partnerShortName,
                    });
                case 'redeem_token_quest':
                    return this.$t('global.transactionTypes.tokensFromHunt');
                case 'kyc_cumulative_limit':
                    return type === 'unlock'
                        ? this.$t('transactionHistory.userVerificationAmountUnlocked')
                        : this.$t('transactionHistory.userVerificationlimitExceeded');
                case 'marketplace_purchase':
                    return type === 'unlock'
                        ? this.$t('global.transactionTypes.tradingMarginRefund')
                        : this.$t('global.transactionTypes.marketplaceBuy');
                case 'marketplace_sale':
                    return this.$t('global.transactionTypes.marketplaceSell');
                default:
                    return this.$t('global.transactionTypes.unknown');
            }
        },
        transactionMixinGetTransactionLogo({
            transactionBatch,
            type,
        }) {
            // Map logo for transaction type
            switch (transactionBatch.type) {
                case 'buy':
                    return {
                        color: '#ffa101',
                        icon: 'topup-icon',
                    };
                case 'deposit':
                    return {
                        color: '#8fc741',
                        icon: 'transfer',
                    };
                case 'withdrawal':
                    return {
                        color: '#1772f2',
                        icon: 'topup',
                    };
                case 'kyc_cumulative_limit':
                    return type === 'unlock' ? {
                        color: '#9B9B9B',
                        icon: 'unlock',
                    } : {
                        color: '#9B9B9B',
                        icon: 'lock',
                    };
                default:
                    return '';
            }
        },
    },
};

export default transactionMixin;